import MUIDataTable from "mui-datatables";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const ReusableMuiTable = ({
  title,
  data = [],
  columns = [],
  options = {},
  customToolbarRight = null,
}) => {
  const goldenColor = "#C39B22";

  const defaultOptions = {
    selectableRows: "none",
    filter: false,
    search: true,
    print: false,
    download: false,
    viewColumns: false,
    responsive: "vertical",
    elevation: 0,
    serverSide: false,
    page: 0,
    count: data.length,
    rowsPerPage: 10,
    rowsPerPageOptions: [10],
    onChangePage: () => { },
    tableBodyMaxHeight: 'auto',
    setTableProps: () => ({
      padding: 'none',
    }),
    customToolbar: () => (
      <Box sx={{ display: "inline-flex", alignItems: "center" }}>
        {customToolbarRight}
      </Box>
    ),
  };

  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "auto",
        "& .MuiToolbar-root": {
          paddingLeft: "0px !important",
          paddingRight: "0px !important",
        },
        "& .MuiTableCell-root": {
          paddingLeft: "0px !important",
          paddingRight: "16px !important",
          paddingTop: "16px !important",
          paddingBottom: "16px !important",
          fontSize: "14px",
          borderBottom: "1px solid #f0f0f0",

        },
        "& .MuiTableCell-head": {
          color: `${goldenColor} !important`,
          fontSize: "16px",
          paddingTop: "12px !important",
          textTransform: 'capitalize',
          paddingBottom: "12px !important",
          whiteSpace: "nowrap",
          "& .MuiButtonBase-root": {
            padding: "0px !important",
            marginLeft: "0px !important",
            textTransform: 'capitalize !important',
            fontSize: "16px"
          },
          "& .MuiTableSortLabel-root": {
            marginLeft: "0px !important",
          },
        },
        "& .MuiTableCell-body": {
          verticalAlign: "middle",
        },
        "& .MuiDataTableBodyCell-root": {
          "&:last-child": {
            color: `${goldenColor} !important`,
            display: "table-cell",
            verticalAlign: "middle",
          },
        },
        "& .MuiTablePagination-spacer": {
          display: "none",
        },
        "& .MuiTablePagination-root": {
          paddingLeft: "0px !important",
        }
      }}
    >
      <MUIDataTable
        title={
          <Typography
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 600,
              fontSize: "20px",
              color: "#000",
            }}
          >
            {title}
          </Typography>
        }
        data={data}
        columns={columns}
        options={{ ...defaultOptions, ...options }}
      />
    </Box>
  );
};

export default ReusableMuiTable;